
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.992 9.075L5.827 11.24c-.893.893-2.319.928-3.169.078-.85-.85-.815-2.276.078-3.17l2.165-2.164-1.03-1.03-2.165 2.165C.212 8.612.154 10.979 1.576 12.4c1.421 1.422 3.788 1.364 5.281-.13l2.165-2.165-1.03-1.03zm-.873-7.368L4.954 3.872l1.03 1.03L8.15 2.737c.893-.893 2.32-.928 3.17-.079.849.85.814 2.276-.08 3.17L9.076 7.992l1.03 1.03 2.165-2.164c1.494-1.494 1.552-3.86.13-5.282C10.98.154 8.614.213 7.12 1.706zm1.518 2.601l-4.33 4.33 1.03 1.03 4.33-4.33-1.03-1.03z","fill":"#585858"}})])
          )
        }
      }
    